import React from 'react';
import { Tool } from '@/types/tool';
import MapInitializer from './MapInitializer';
import './mapStyles.css';
import mapboxgl from 'mapbox-gl';

interface MapContainerProps {
  tools: Tool[];
  onLocationSelect?: (location: { lat: number; lng: number; formattedAddress: string }) => void;
  selectedLocation?: { lat: number; lng: number };
  isSelectingLocation?: boolean;
  defaultCenter?: { lat: number; lng: number };
  defaultZoom?: number;
  mapRef?: React.MutableRefObject<mapboxgl.Map | null>;
  isMobile?: boolean;
}

const MapContainer = ({ 
  tools, 
  onLocationSelect, 
  selectedLocation, 
  isSelectingLocation,
  defaultCenter,
  defaultZoom,
  mapRef,
  isMobile
}: MapContainerProps) => {
  return (
    <div className="relative w-full h-full overflow-hidden rounded-b-lg">
      <MapInitializer
        tools={tools}
        onLocationSelect={onLocationSelect}
        selectedLocation={selectedLocation}
        isSelectingLocation={isSelectingLocation}
        defaultCenter={defaultCenter}
        defaultZoom={defaultZoom}
        mapRef={mapRef}
        isMobile={isMobile}
      />
    </div>
  );
};

export default MapContainer;